<!--Tabindex in this case is fix focusable vertical line in firefox from task UM-1583 -->
<div class="mc-navigation" tabindex="-1">
  <mc-team-selector [isSidenavOpened]="isSidenavOpened"></mc-team-selector>
  <div class="mc-navigation__separator-line"></div>

  @if (isDashboardUpdating()) {
    <div class="skeleton">
      <div class="skeleton-add-btn"></div>
      @for (menuItem of menuItems; track menuItems.length) {
        <div class="skeleton-menu-item"></div>
      }
    </div>
  } @else {
    <!--  // TODO: Thinking about how to make a directive wrapper to reduce ifs-->
    <ng-container *onlyRegTrackModeGuard="RegTrackMode.AddSiteBtn">
      <ng-container *permissionGuard="UserPermissions.manageSites.addSiteService">
        @if (isSidenavOpened && !isGoogle) {
          <mc-button
            (click)="onAddSite()"
            class="mc-navigation__new-project-btn"
            variant="stroked"
            color="primary"
            width="full-width"
            data-testid="navigation.add-sites-button"
          >
            <span class="mc-navigation__new-project-btn-content">
              <mat-icon
                aria-label="plus icon"
                aria-hidden="false"
                svgIcon="plus"
                class="mc-navigation__icon-plus"
                alt="icon-plus"
              ></mat-icon>
              <span class="mc-navigation__new-project-btn-title">Add Site</span>
            </span>
          </mc-button>
        }
      </ng-container>
    </ng-container>

    @if (isUserDataLoaded) {
      <mc-nav-menu [hidden]="!isSidenavOpened" class="mc-navigation__menu" [menuItems]="menuItems"></mc-nav-menu>
    }
  }
  @if (isSidenavOpened) {
    <div class="mc-navigation__bottom">
      <ng-container *onlyRegTrackModeGuard="RegTrackMode.BecomePartnerUrl">
        <ng-container *permissionGuard="UserPermissions.becomeAPartnerLink">
          @if (!authService.isAgency && !isPartner) {
            <mc-button
              variant="link"
              class="become-partner-button"
              target="_blank"
              aria-label="Become a partner form opens in a new tab"
              (click)="openBecomePartnerPage()"
            >
              <span> Become a Partner </span>
            </mc-button>
          }
        </ng-container>
      </ng-container>
    </div>
  }
</div>
